import React from 'react';
import 'react-day-picker/lib/style.css';
import {useTranslation} from "react-i18next";

const NewDataButton = (props) => {
    const [t] = useTranslation();
    const openNewData = () => {
        let r = `${props.route}/add`;
        r = r.replace('//', '/');
        props.history.push(r);
    };
    let newItemButton = null;
    let className = props.className ? props.className : "btn btn-success mr-1";
    if (props.roleMenu.quyentaomoi === 1) {
        newItemButton = (
            <button
                className={className}
                type="button"
                onClick={openNewData}
            >
                <i className="fa fa-plus"> {t('action.label.add')} </i>

            </button>
        );
    }
    // console.log('nameState', JSON.stringify(props, null, 2));
    return newItemButton;
};

export default NewDataButton;
